"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainNavItem = void 0;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_router_1 = require("react-router");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
exports.MainNavItem = React.forwardRef((props, ref) => {
    var _a, _b;
    const { nav, classes, selected, displayNode, iconSize, closeHeader, iconRef, canOpenSubMenu, handleTracking, disableClick = false, renderSubMenuItems = null, } = props;
    const IconComponent = nav.img;
    const aId = nav.id || ((_a = `nav-menu-${(nav.title || 'default')}`) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(' ', '-').replace('/', ''));
    let { path } = nav;
    const cutSelected = (selected) ? `/${selected.split('/')[1]}` : '';
    const hasSubMenu = ((_b = nav === null || nav === void 0 ? void 0 : nav.subMenuItems) === null || _b === void 0 ? void 0 : _b.length) >= 1;
    if (nav.useSelectedAccount) {
        path = `${path}?displayNode=${displayNode}`;
    }
    const subMenuShown = React.useRef(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleParentHover = (event) => {
        if (anchorEl !== event.currentTarget) {
            setAnchorEl(event.currentTarget);
        }
        // The sub-menu opens on hover without moving focus into it (autoFocus={false}).
        // If the trigger already holds DOM focus (e.g. from a prior click/tab), the Menu's
        // Modal marks this button's ancestor tree as aria-hidden while focus is still inside
        // it, which the browser blocks and logs as a console warning. Blur it here instead.
        if (document.activeElement === event.currentTarget) {
            event.currentTarget.blur();
        }
    };
    const onMenuItemClick = () => {
        handleTracking(path);
        setTimeout(() => {
            subMenuShown.current = false;
            setAnchorEl(null);
            closeHeader();
        }, 500);
    };
    const onLeaveParentMenu = () => {
        setTimeout(() => {
            if (!subMenuShown.current) {
                setAnchorEl(null);
            }
        }, 100);
    };
    const onSubMenuMouseOver = () => {
        subMenuShown.current = true;
    };
    return (<>
      <ButtonBase_1.default onClick={onMenuItemClick} className={(0, classnames_1.default)(classes.navMenuItem, cutSelected === nav.path && classes.selectedItem)} // classes.navButton}
     to={disableClick ? null : path} 
    // @ts-expect-error: No overload matches this call.
    component={disableClick ? null : react_router_1.NavLink} id={aId} ref={ref} onMouseEnter={!hasSubMenu ? null : handleParentHover} onMouseLeave={!hasSubMenu ? null : onLeaveParentMenu}>
        {/* Below will keep the full nav item w/ darker background color when selected */}
        <span ref={iconRef}>
          <IconComponent title={nav.alt} fill="currentColor" height={iconSize} width={iconSize}/>
        </span>
        <Typography_1.default style={{ marginLeft: 24, textAlign: 'left' }} className={cutSelected === nav.path ? classes.selectedNavText : classes.navText}>
          {nav.title}
          {hasSubMenu && <ChevronRight_1.default className={classes.mainNavChevronRightIcon}/>}
        </Typography_1.default>
      </ButtonBase_1.default>
      {hasSubMenu && canOpenSubMenu && (<Menu_1.default id="main-nav-sub-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onMenuItemClick} MenuListProps={{
                onMouseLeave: onMenuItemClick,
                onMouseEnter: onSubMenuMouseOver,
                onClick: renderSubMenuItems ? onMenuItemClick : undefined,
            }} autoFocus={false} className={classes.mainNavSubMenu}>
          {renderSubMenuItems || nav.subMenuItems.map((subMenuItem) => (<MenuItem_1.default key={subMenuItem.title} onClick={onMenuItemClick} to={subMenuItem.path} component={react_router_1.NavLink}>
              {subMenuItem.title}
            </MenuItem_1.default>))}
        </Menu_1.default>)}
    </>);
});
